<div class="table-header-cell">
  <span
    class="table-header-cell__content-container"
    [class.tw:cursor-pointer]="withSorting()"
    #cellContent
    (click)="withSorting() && cycleSort(column.name())"
  >
    @if (icon()) {
      <fr8bot-ui-icon [name]="icon()" [size]="16" class="table-header-cell__icon"></fr8bot-ui-icon>
    }

    <span class="table-header-cell__content">
      <ng-content></ng-content>
    </span>

    @if (withSorting()) {
      <span class="table-header-cell__sort">
        <button
          class="table-header-cell__sort-button table-header-cell__sort-button--top"
          [class.table-header-cell__sort-button--selected]="
            sortService.order() | tableActiveSort: column.name() : 'ASC' : sortService.config()
          "
          (click)="$event.stopPropagation(); sortBy(column.name(), 'ASC')"
        >
          <fr8bot-ui-icon name="arrow-up-12" [size]="12" />
        </button>

        <button
          class="table-header-cell__sort-button table-header-cell__sort-button--bottom"
          [class.table-header-cell__sort-button--selected]="
            sortService.order() | tableActiveSort: column.name() : 'DESC' : sortService.config()
          "
          (click)="$event.stopPropagation(); sortBy(column.name(), 'DESC')"
        >
          <fr8bot-ui-icon name="arrow-down-12" [size]="12" />
        </button>
      </span>
    }
  </span>
  <span [id]="RESIZE_HANDLE_ID" class="resize-handle" [style.width.px]="RESIZE_HANDLE_WIDTH"></span>
</div>
